import { apiCall } from "./index";

export const updateWorkCalendar = (formData) => {
  return apiCall(`/work-calendar/update`, "POST", formData, null, true);
};